import { Controller } from '@hotwired/stimulus'

import Litepicker from 'litepicker';

export default class extends Controller {
  static targets = [
    'apply',
    'startDate',
    'endDate',
    'singleDayEdit'
  ];

  static values = {
    layoutId: Number
  }

  connect() {
    this.BASE_URL = '/sandbar/admin/layouts/'

    if (this.litePicker) {
      this.litePicker.clearSelection()
    }
  }

  showDateSelectors = _event => {
    if (this.litePicker) {
      this.litePicker.destroy();
    }

    this.enableDateSelectors(this.singleModeEdit);
    this.litePicker.show();
  }

  enableDateSelectors = (singleDayEdit = false) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // today beginning of day in timezone for minDate in options below

    const options = {
      resetButton: true,
      element: this.startDateTarget,
      tooltipText: { one: 'day', other: 'days' },
      singleMode: singleDayEdit,
      elementEnd: this.endDateTarget,
      format: 'MM/DD/YYYY',
      maxDays: 30,
      numberOfMonths: 2,
      numberOfColumns: 2,
      switchingMonths: 1,
      allowRepick: true,
      minDate: today,
      setup: picker => {
        picker.on('hide', () => {
          this.onDatePickerHide();
        })
        picker.on('selected', (_date1, _date2) => {
          picker.hide();
        });
      },
    };

    this.litePicker = new Litepicker(options);
  }

  onDatePickerHide = () => {
    this.startDate = this.startDateTarget.value ? new Date(this.startDateTarget.value).toUTCString() : null
    this.endDate = this.endDateTarget.value ? new Date(this.endDateTarget.value).toUTCString() : null
    if (this.startDate && (this.endDate || this.singleModeEdit)) {
      this.enableApply(true);
    } else {
      this.enableApply(false)
    }
  }

  enableApply(bool) {
    if (bool) {
      this.applyTarget.removeAttribute('disabled')
    } else {
      this.applyTarget.setAttribute('disabled', true)
    }
  }

  toggleSingleDayEditing = () => {
    this.singleModeEdit = this.singleDayEditTarget.checked

    if (this.singleModeEdit) {
      this.endDateTarget.setAttribute('disabled', true)
    } else {
      this.endDateTarget.removeAttribute('disabled')
    }

    if (this.litePicker) {
      this.litePicker.clearSelection()
    }
  }

  handleFilterEdit() {
    window.location.href = `/sandbar/admin/layout_filters/new?layout_id=${this.layoutIdValue}&start_date=${this.startDate}&end_date=${this.endDate}`;
  }

  handleBaseEdit() {
    window.location.href = `${this.BASE_URL}${this.layoutIdValue}/edit`;
  }
}
